<template>
  <div>
    <h1>Editar Tipo_concedente</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("tipos_concedentes", ["tipo_concedente"]),
  },
  methods: {
    ...mapActions("tipos_concedentes", [
      "ActionNewTipoConcedente",
      "ActionShow",
    ]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "tipos_concedentes_list" });
      }
    },
  },
  async created() {
    this.ActionNewTipoConcedente();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
